var map = {
	"./bug.svg": 384,
	"./dark.svg": 970,
	"./dragon.svg": 431,
	"./electric.svg": 703,
	"./fairy.svg": 817,
	"./fighting.svg": 932,
	"./fire.svg": 394,
	"./flying.svg": 591,
	"./ghost.svg": 715,
	"./grass.svg": 448,
	"./ground.svg": 487,
	"./ice.svg": 648,
	"./normal.svg": 971,
	"./poison.svg": 438,
	"./psychic.svg": 91,
	"./rock.svg": 521,
	"./steel.svg": 11,
	"./water.svg": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;